import React from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import moment from 'moment';

const boxStyle = css`
  border: 0.0625rem solid #ddd9d5;
  border-radius: 0.5625rem 0.5625rem 0.625rem 0.625rem;
  padding: 0.75rem 1.25rem 0.75rem 1.25rem;
  width: fit-content;
  height: fit-content;
  color: #7b1a27 !important;
  font-weight: 600;
  text-align: center;
  background-color: #fff;
`;

const dowStyles = css`
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

const monthStyle = css`
  font-size: 0.75rem;
  line-height: 1.125rem;
  white-space: nowrap;
`;

const OrderDate = ({ orderDate }) => {
  const date = orderDate ? moment(orderDate, 'YYYY-M-D') : moment('2024-01-01');
  const dayOfWeek = date.format('ddd');
  const month = date.format('MMM');
  const dayOfMonth = date.format('DD');
  const dateLabel = date.format('dddd, MMMM Do');

  return (
    <div className={boxStyle} aria-label={dateLabel}>
      <div className={dowStyles} aria-hidden={true}>
        <span>{dayOfWeek}</span>
      </div>
      <div className={monthStyle} aria-hidden={true}>
        <span>
          {month} {dayOfMonth}
        </span>
      </div>
    </div>
  );
};

OrderDate.propTypes = {
  orderDate: PropTypes.string.isRequired,
};

export default OrderDate;
